import React from "react";
import Link from "next/link";
import Image from "next/image";
import { HeaderSection } from "@/.storyblok/types/319751/storyblok-components";
import Social from "@/components/layouts/Social";
import { SbBlokData } from "@storyblok/react";
interface AboutProps {
  blok: HeaderSection & SbBlokData;
}

const About: React.FC<AboutProps> = ({ blok }) => {
  if (!blok) return null;

  return (
    <div className="dropdown-menu" aria-labelledby="dropdown-about">
      <div className="container">
        <div className="row g-0">
          {/* About Links Section */}
          <div className="col col-lg-8 col-xl-6 border-start">
            <div className="navbar-title h4">{blok.title || "About"}</div>
            <div className="m-4">
              <ul className="list-unstyled row navbar-icon-links">
                {blok?.items?.map((item) => (
                  <li key={item._uid} className="col-24">
                    <Link
                      href={item.link?.url || "#"}
                      target={item.is_external ? "_blank" : "_self"}
                      rel={item.is_external ? "noopener noreferrer" : undefined}
                      className="d-flex text-decoration-none p-2 mx-n2"
                    >
                      {item.using_icon && (
                        <i
                          className={`fas fa-${item.icon_class} fa-fw me-2 lh-base`}
                        ></i>
                      )}
                      <div>
                        <span className="h4 d-block mb-1">{item.label}</span>
                        <span className="d-block mb-0 text-muted small">
                          {item.icon_description}
                        </span>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* About Description Section */}
          <div className="d-none d-lg-flex col col-lg-16 col-xl-12 border-start d-flex flex-column">
            <div className="navbar-title h4 mb-0">
              {blok.center_title || "A trusted security partner"}
            </div>
            <div className="m-4">
              <div className="h3">{blok.center_top_text}</div>
              <p className="lead navbar-main-text">{blok.center_description}</p>
            </div>
            {blok.using_socials && blok.socials && blok.socials.length > 0 && (
              <div className="p-4 mt-auto border-top text-center">
                <span className="text-muted me-2">
                  Keep in touch with us on social media:
                </span>
                <Social color="dark" social_links={blok.socials} />
              </div>
            )}
          </div>

          {/* Contact Us Section */}
          <div className="d-none d-xl-block col col-lg-6 border-start border-end bg-light">
            <div className="navbar-header-img">
              <Image
                src={blok.right_image?.filename || ""}
                width={653}
                height={435}
                alt={blok.right_image?.alt || "Contact Us"}
                className="img-fluid img-cover"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                loading="lazy"
                quality={75}
              />
            </div>
            <div className="m-4">
              <div className="h3 mb-3">{blok.right_title || "Get in touch"}</div>
              <p className="mb-4">{blok.right_description}</p>
              <Link
                href={blok.right_cta_link?.url || "#"}
                className="btn btn-primary rounded-pill d-block"
              >
                {blok.right_cta || "Contact Us"}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;